<template>
  <div class="ras-person ras-page">
    <div class="ras-page__header">
      <h1 class="ras-page__question">Who's watching?</h1>
      <p class="ras-page__info">Select your gender and age group</p>
    </div>
    <form class="ras-page__form" @submit.prevent="nextStep">
      <div class="radio-wrapper ras-page__form__item">
        <RadioButton :selected="checkedGender" :options="genders" v-model="form.gender"></RadioButton>
      </div>
      <div class="dropdown-wrapper ras-page__form__item">
        <Dropdown :default="checkedAge" @select="setAge" :options="ageGroups" />
      </div>
      <div class="button-wrapper">
        <button :class="['ras-button', {'ras-button--disabled': !formValid}]">Next Step</button>
      </div>
    </form>
  </div>
</template>

<script>
import RadioButton from '@/components/RadioButton.vue'
import Dropdown from '@/components/Dropdown.vue'
export default {
  name: 'Person',
  components: {
    RadioButton,
    Dropdown
  },
  data: () => ({
    genders: [
      'male',
      'female',
      'other'
    ],
    ageGroups: {
      under18: 'Up to 18',
      '18-29': '18-29',
      '30-44': '30-44',
      '45Plus': '45+'
    },
    form: {
      gender: '',
      age: ''
    },
    checkedGender: '',
    checkedAge: '',
    formValid: false,
  }),
  methods: {
    setAge(event) {
      this.form.age = event
    },
    nextStep() {
      if(this.formValid) {
        this.$store.dispatch('setFormData', this.form).then(() => {
          this.$router.push({ path: 'genres' })
        })
      }
    }
  },
  mounted() {
    if(this.$store.getters.getFormByKey('gender').length) {
      this.checkedGender = this.$store.getters.getFormByKey('gender')
      this.form.gender = this.$store.getters.getFormByKey('gender')
    }
    else {
      this.form.gender = ''
    }
    if(this.$store.getters.getFormByKey('age').length) {
      this.checkedAge = this.$store.getters.getFormByKey('age')
      this.form.age = this.$store.getters.getFormByKey('age')
    }
    else {
      this.form.age = ''
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.formValid = Object.keys(this.form).every(key => this.form[key] !== '')
      },
    }
  }
}
</script>

<style lang="scss">
  .ras-person {
    .ras-page__form {
      margin-bottom: 40px;

      @media (min-width: map_get($breakpoints, lg)) {
        margin-bottom: 0;
      }
    }
  }
</style>